import { render, staticRenderFns } from "./desempenho-carteira.vue?vue&type=template&id=cf9c7e6a&scoped=true&"
import script from "./desempenho-carteira.vue?vue&type=script&lang=js&"
export * from "./desempenho-carteira.vue?vue&type=script&lang=js&"
import style0 from "./desempenho-carteira.vue?vue&type=style&index=0&id=cf9c7e6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9c7e6a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf9c7e6a')) {
      api.createRecord('cf9c7e6a', component.options)
    } else {
      api.reload('cf9c7e6a', component.options)
    }
    module.hot.accept("./desempenho-carteira.vue?vue&type=template&id=cf9c7e6a&scoped=true&", function () {
      api.rerender('cf9c7e6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Rentabilidade/components/desempenho-carteira.vue"
export default component.exports